module.exports = __webpack_public_path__ + "img/yonghu4.b8ac46f3.png";